import { ErrorMessage } from 'formik';
import { ReactNode } from 'react';

import { Label, StyledErrorMessage, StyledField, Wrapper } from './styled';

interface IProps {
  name: string;
  label?: string;
  children?: ReactNode;
  fullWidth?: boolean;
  [key: string]: any;
  disabled?: boolean;
}

export const Field = ({
  name,
  label,
  children,
  fullWidth = false,
  disabled,
  ...rest
}: IProps) => {
  const renderFieldContent = () => {
    if (children) {
      return (
        <StyledField id={name} name={name} {...rest}>
          {children}
        </StyledField>
      );
    }

    return <StyledField disabled={disabled} id={name} name={name} {...rest} />;
  };
  return (
    <Wrapper fullWidth={fullWidth}>
      {label && <Label htmlFor={name as string}>{label}</Label>}
      {renderFieldContent()}

      <StyledErrorMessage>
        <ErrorMessage name={name as string} />
      </StyledErrorMessage>
    </Wrapper>
  );
};
